import React from 'react';
import { NavigationSection } from '~/hooks/useNavigation';
import ArrowRightIcon from '~/public/static/svg/ArrowRightIcon';

interface Props {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  sections: NavigationSection[];
}

const DesktopHeaderCmsNavigationSections: React.FC<Props> = ({
  onClick,
  sections,
}) => {
  const childCx =
    'cursor-pointer transition duration-200 text-slate-green-500 hover:text-turf-green-500 block px-4 py-1 hover:underline';

  const headerCx =
    'break-inside-avoid cursor-pointer transition duration-200 mb-1 text-base font-semibold block px-4 py-1 hover:underline';

  return (
    <div className="columns-3xs gap-x-4">
      {sections.map((section, i) => (
        <ul key={i} className="break-inside-avoid">
          <li role="presentation">
            <a
              href={section.destination || '#'}
              className={headerCx}
              onClick={onClick}
            >
              <span className="flex items-center space-x-1">
                <span>{section.title}</span>
                <ArrowRightIcon className="h-6 w-6" />
              </span>
            </a>
          </li>

          {section.children.map((child, j) => (
            <li key={j} className="first:mt-4 last:mb-4">
              <a
                href={child.destination || '#'}
                className={childCx}
                onClick={onClick}
              >
                {child.title}
              </a>
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
};

export default DesktopHeaderCmsNavigationSections;
